import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'

const DisableLinksPlugin = ({ disabled }: { disabled: boolean }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerRootListener((rootElement) => {
      if (!rootElement) return null

      const handleClick = (event: MouseEvent) => {
        if (disabled) {
          const target = event.target as HTMLElement

          // Check if the target is a link or has a link ancestor
          const linkElement = target.closest('a')

          if (linkElement) {
            console.log('DisableLinksPlugin: Preventing link click')
            event.preventDefault()
            event.stopPropagation()

            return false
          }
        }

        return undefined
      }

      // Use capture phase to ensure we catch the event before it bubbles
      rootElement.addEventListener('click', handleClick, true)

      return () => {
        rootElement.removeEventListener('click', handleClick, true)
      }
    })
  }, [editor, disabled])

  return null
}

export default DisableLinksPlugin
